import { Link } from '@mui/material';

const LAW_TAG_PATTERN = /^(.*)<law>(.*)<\/law>(.*)$/s;

/** Testo tradotto con il riferimento normativo racchiuso in `<law>…</law>`: il solo riferimento diventa il link alla fonte ufficiale. */
export function LawTaggedText({ text, href }: { text: string; href: string }) {
  const parts = LAW_TAG_PATTERN.exec(text);
  if (!parts) {
    return <>{text}</>;
  }
  return (
    <>
      {parts[1]}
      <Link href={href} target="_blank" rel="noopener noreferrer">
        {parts[2]}
      </Link>
      {parts[3]}
    </>
  );
}
